import { NavLink } from 'react-router'
import { FolderUp, Images, Plus, Search, ShieldCheck } from 'lucide-react'
import { useAuth } from '@/hooks/use-auth'
import { cn } from '@/lib/utils'

/** Thumb-reachable navigation for phones and small tablets. */
export function MobileNav({ onSearch }: { onSearch: () => void }) {
  const { isAdmin } = useAuth()
  const item = (active: boolean) =>
    cn(
      'flex flex-1 flex-col items-center justify-center gap-1 py-2 text-[11px] font-medium transition-colors',
      active ? 'text-primary' : 'text-muted-foreground',
    )

  return (
    <nav
      aria-label="Main"
      className="glass pb-safe fixed inset-x-0 bottom-0 z-40 rounded-t-2xl border-x-0 border-b-0 md:hidden"
    >
      <div className="mx-auto flex h-16 max-w-lg items-stretch px-2">
        <NavLink to="/" end className={({ isActive }) => item(isActive)}>
          <Images className="size-5" />
          Gallery
        </NavLink>
        <button type="button" onClick={onSearch} className={item(false)}>
          <Search className="size-5" />
          Search
        </button>
        <NavLink to="/upload" className="flex flex-1 items-center justify-center" aria-label="Upload">
          {({ isActive }) => (
            <span
              className={cn(
                'flex size-12 items-center justify-center rounded-2xl bg-brand-gradient text-white shadow-glow transition-transform active:scale-95',
                isActive && 'ring-2 ring-primary/40 ring-offset-2 ring-offset-background',
              )}
            >
              <Plus className="size-6" />
            </span>
          )}
        </NavLink>
        <NavLink to="/me" className={({ isActive }) => item(isActive)}>
          <FolderUp className="size-5" />
          Mine
        </NavLink>
        {isAdmin && (
          <NavLink to="/admin" className={({ isActive }) => item(isActive)}>
            <ShieldCheck className="size-5" />
            Admin
          </NavLink>
        )}
      </div>
    </nav>
  )
}
